<template>
  <div class="pt-24 px-8">
    <div class="bg-card bg-white card-shadow dashboard-card border-card-border">
      <div class="container md:px-16 pt-16 pb-6 flex flex-col items-center justify-center">
        <h1 class="text-center text-xl font-semibold text-default pb-4">
          {{ title }}
        </h1>
        <h2 class="text-center md:px-16 text-black-600" v-html="subTitle" />

        <img alt="img" :src="img" class="md:w-1/3 my-4" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContractSigned',
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    img() {
      return require('@/assets/img/sketches/transferMoney.svg')
    },
    title() {
      return 'All Done!'
    },
    subTitle() {
      return 'Your funds will now be sent to the bank account you linked during your loan application. <br>Please give us a call at <a class="underline" href="tel:6786858834">+1 (678) 685-8834</a> with any questions. <br> Thank you for choosing VIVA Finance!'
    }
  }
}
</script>
